import Axios from "helpers/Interceptor"
import * as Sentry from "@sentry/browser"

export const getCampaignsDashboard_api = async ({
    brandId,
    clientId,
    key,
    isAll,
    isAllSymphony
}: {
    brandId?: number,
    clientId?: number,
    key?: string,
    isAll?: boolean,
    isAllSymphony?: boolean
}) => {
    try {
        const response = await Axios.post(`/v2/fetch-campaigns-dashboard`, {
            params: {
                brandId,
                clientId,
                key,
                isAll,
                isAllSymphony
            }
        });
        return response.data;
    } catch (error) {
        Sentry.captureException(error);
        return null;
    }
}